import type { ReactNode } from 'react';
import React from 'react';
import { Card, CardSection, Grid, GridColumn, GridRow } from '@axiom/ui';

export type AdminModalSearchListDetailProps = {
  name: string;
  list: ReactNode;
  detail: ReactNode;
};

export const AdminModalSearchListDetail = ({
  name,
  list,
  detail,
}: AdminModalSearchListDetailProps) => (
  <Grid name={name}>
    <GridRow>
      <GridColumn width={5}>{list}</GridColumn>
      <GridColumn width={7}>
        <Card>
          <CardSection>{detail}</CardSection>
        </Card>
      </GridColumn>
    </GridRow>
  </Grid>
);
